import React, { Component } from 'react';
import queryString from "query-string";
import Axios from 'axios';
import Helmet from 'react-helmet';
import { Link } from "react-router-dom";


// utils
import SviChartTable from '../SviChartTable';
import SviChartLine from '../SviChartLine';
import chartCapture from '../../utils/Shared/chartCapture';
import LoadingDots from '../../utils/LoadingDots';
import CustomSelect from '../../utils/CustomSelect';
import CustomDropdown from '../../utils/CustomDropdown';
import SocialBlock from '../../utils/SocialBlock';
import LimitMask from '../../utils/LimitMask';
import CustomCheckbox from "../../utils/CustomCheckbox";

// methods
import gaTracking from '../../utils/Shared/gaTracking';
import {apiHost} from '../../utils/Shared/constant';
import { loginRedirect, downloadTrigger, urlPushState } from '../../utils/Shared/methods';

// rsuite
import { TagPicker, Tag, Toggle, Animation } from 'rsuite';
import ArrowDownLineIcon from '@rsuite/icons/ArrowDownLine';
import CloseIcon from '@rsuite/icons/Close';
// import "rsuite/dist/rsuite.css";
import "rsuite/TagPicker/styles/index.css";
import "rsuite/Tag/styles/index.css";
import "rsuite/Toggle/styles/index.css";

import './index.scss';


class SviChart extends Component {
	constructor(params) {
		super(params);
		this.state = {
			type: 's',
      		isMemberLogin: false,
			availableIndicators: null,
			allIndicators: [],
			indicatorsDetails: [],
			categoryDescription: null,
			currentCounty: '0',
			currentCountyName: '',
			currentIndicators: [],
			currentIndicatorsId: [],
			currentIndicatorId: '0',
			currentIndicatorsName: [],
			currentIndicatorDescription: '',
			isChartShow: true,
			isBasicLoading: false,
			isBasicLoaded: false,
			isAdvanceLoading: false,
			isDataLoaded: false,
			selectedCounty: null,
			selectedTown: null,
			countiesData: null,
			townsData: null,
			sviData: [],
			csvData: [],
			originCsvData: [],
			// 測試
			legendSelected: null,
			isValid: false,
			selectedAvailableIndicators: [[],[],[],[]],
			availableIndicatorsValue: [[],[],[],[]],
			// availableIndicatorsValue: [['10108', '60'],[],['102', '70', '71', '79'],[]],
			availableIndicatorsValuePlus: [[],[],[],[]],
			availableIndicatorsValueItems: [[],[],[],[]],
			availableIndicatorsValueItemsPlus: [[],[],[],[]],
			availableIndicatorsData: [],
			pickIndicatorsId: [[],[],[],[],[]],			
			isING: false,
			selectedCountyTmp: null,
			selectedTownTmp: null,
			selectedTownCode: '', // 新增：追蹤選擇的鄉鎮代碼
			isQuery: false,
			availableIndicatorsValueQuery: [],
			isShowCollapse: [true, true, true, true, true],
			tableCollapseToggle: false,
			categoryChecked: [false, false, false, false],
			isRestoringFromSession: false // 標記是否正在從 sessionStorage 恢復狀態
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.props.onLoadHeaderColor('BLUE');
		this.props.onLoadHeaderTheme('DARK');
		this.props.onLoadShowLanguage('HIDE');

		const breadcrumb = [
			{ name: '首頁', href: '/' },
			{ name: '社會脆弱度評估', href: '/evaluation/svi' },
			{ name: '社會脆弱度指標查詢與展示', href: '/evaluation/svi/s' },
		]
		this.props.onLoadShowBreadcrumb('SHOW', breadcrumb);

		this.checkMemberLogin();

		// 檢查是否有儲存的查詢狀態
		const hasSavedState = sessionStorage.getItem('svi_query_state');

		this.getQuery();
		this.getCategoryDescription();
    	this.getCountiesTownsData().then(() => {
			if (hasSavedState) {
				// 有儲存狀態，直接恢復
				this.restoreQueryStateFromSession();
			}
		});
		this.getAllIndicators();
	}
	// componentDidUpdate(prevProps, prevState) {
	// 	if (prevProps.availableIndicatorsValue !== this.state.availableIndicatorsValue) { 
	// 		console.log('availableIndicatorsValue',this.state.availableIndicatorsValue)
	//   	} 
  	// }
	checkMemberLogin = () => {
		if (window.localStorage.getItem('user-token')) {
		this.setState({ isMemberLogin: true });
		}
	}
	restoreQueryStateFromSession = () => {
		const savedState = sessionStorage.getItem('svi_query_state');
		if (savedState) {
			try {
				const state = JSON.parse(savedState);

				// 先儲存需要在查詢後恢復的狀態
				this.pendingRestoreState = {
					availableIndicatorsValue: state.availableIndicatorsValue,
					csvData: state.csvData,
					originCsvData: state.originCsvData,
					sviData: state.sviData,
					currentTitle: state.currentTitle,
					availableIndicatorsValuePlus: state.availableIndicatorsValuePlus,
					availableIndicatorsValueItemsPlus: state.availableIndicatorsValueItemsPlus,
					currentIndicatorsId: state.currentIndicatorsId,
					availableIndicatorsData: state.availableIndicatorsData,
					isDataLoaded: state.isDataLoaded,
					pickIndicatorsId: state.pickIndicatorsId || [[0],[],[],[],[]],
					currentIndicators: state.currentIndicators || [],
					categoryChecked: state.categoryChecked || [false, false, false, false],
				};

				// 先恢復縣市鄉鎮選擇
				this.setState({
					selectedCountyTmp: state.selectedCountyTmp,
					selectedTownTmp: state.selectedTownTmp,
					selectedTownCode: state.selectedTownCode,
					townsData: state.selectedCountyTmp ? state.selectedCountyTmp.towns : null,
					isRestoringFromSession: true,
				}, () => {
					// 清除已使用的 session storage
					sessionStorage.removeItem('svi_query_state');
					// 重新執行查詢以取得 availableIndicators
					this.handleGetBasicData();
				});
			} catch (error) {
				console.error('恢復查詢狀態失敗:', error);
				sessionStorage.removeItem('svi_query_state');
				this.setState({ isRestoringFromSession: false });
			}
		}
	}
	updateSessionStorage = () => {
		// 如果已經有查詢結果，就更新 sessionStorage
		if (this.state.isDataLoaded) {
			const { selectedCountyTmp, selectedTownTmp, selectedTownCode, availableIndicatorsValue,
					csvData, originCsvData, sviData, currentTitle, availableIndicatorsValuePlus,
					availableIndicatorsValueItemsPlus, currentIndicatorsId, availableIndicatorsData,
					pickIndicatorsId, currentIndicators, categoryChecked, availableIndicators,
					selectedAvailableIndicators, allIndicators, indicatorsDetails } = this.state;

			sessionStorage.setItem('svi_query_state', JSON.stringify({
				selectedCountyTmp,
				selectedTownTmp,
				availableIndicatorsValue,
				selectedTownCode,
				csvData,
				originCsvData,
				sviData,
				currentTitle,
				availableIndicatorsValuePlus,
				availableIndicatorsValueItemsPlus,
				currentIndicatorsId,
				availableIndicatorsData,
				isDataLoaded: true,
				pickIndicatorsId,
				currentIndicators,
				categoryChecked,
				availableIndicators,
				selectedAvailableIndicators,
				allIndicators,
				indicatorsDetails
			}));
		}
	}
	getQuery() {		
		const report = queryString.parse(window.location.search);
		console.log('report', report);

		if (report.indicator && report.county) {
			this.setState({
				isQuery: true,
			})
			const county = report.county;
			const town = report.town;
			let indicators = typeof report.indicator === 'string' ? [report.indicator] : report.indicator;
			indicators = indicators.slice(1);
			let availableIndicatorsValueQuery = [];
			let tempArr = [];
			for (let i = 0; i < indicators.length; i++) {
				if (indicators[i] === '1' || indicators[i] === '2' || indicators[i] === '3' || indicators[i] === '4') {
					if (tempArr.length > 0) {
						availableIndicatorsValueQuery.push(tempArr);
						tempArr = [];
					}
				}
				tempArr.push(indicators[i]);
			}
			
			if (tempArr.length > 0) {
				availableIndicatorsValueQuery.push(tempArr);
			}
			// 移除indicator 1~4
			availableIndicatorsValueQuery.forEach((item, index)=>{
				availableIndicatorsValueQuery[index].shift()
			})
			
			console.log(1)
			this.getCountiesTownsData().then(() => {
				this.handleCountyDistrictPickSelected(county).then(() => {
					this.setState({
						availableIndicatorsValueQuery,
					}, ()=>{
						console.log('availableIndicatorsValueQuery', this.state.availableIndicatorsValueQuery)
						// this.handleTownDistrictPickSelected(town)
						this.handleGetBasicData();
					})
				})
			});
		}
	}
	getCategoryDescription() {
		Axios.get(`${apiHost}/api/WeakIndex/GetCategoriesDetail`)
		.then(res => {
			res.status === 200 && this.setState({categoryDescription: res.data.Result})
		})
	}
	getAllIndicators() {
		// Axios.get(`${apiHost}/api/WeakIndex/ZIndicatorsByYear?year=2010&county=all`)
		Axios.get(`${apiHost}/api//WeakIndex/GetCompleteIndicator`)
		.then((res) => {
			if (res.status === 200) {
				const { categories, subcategories, indicators } = res.data.Result;
				categories.forEach((item) => {
					item.name = item.category_name;
				});
				subcategories.forEach((item) => {
					item.name = item.subcategory_name;
				});
				const allIndicators = [].concat(categories, subcategories, indicators);
				const indicatorsDetails = indicators
				this.setState({
					indicatorsDetails,
					allIndicators,
				})
			}
		})
	}
	getCountiesTownsData = () => {
		return new Promise(resolve => {
		const { countiesData } = this.state;
		if (countiesData === null) {
			Axios.get('/config/CountiesTownsData.json')
			.then(result => {
			const { counties } = result.data;
			this.setState({ countiesData: counties }, () => resolve());
			})
		}
		})
	}
	handleSelectIndicator = (e) => {
		const id = e.currentTarget.dataset.id;
		const { currentIndicatorsId } = this.state;

		if (currentIndicatorsId.indexOf(id) === -1 && currentIndicatorsId.length < 10) {
			currentIndicatorsId.push(id);
		}
		else if (currentIndicatorsId.indexOf(id) !== -1) {
			const index = currentIndicatorsId.indexOf(id);
			currentIndicatorsId.splice(index, 1);
		}

		this.setState({
			currentIndicatorsId: currentIndicatorsId,
		}, () =>{
			this.handleUpdateIndicators();
			// console.log('currentIndicatorsId', currentIndicatorsId)
		});
	}
	handleUpdateIndicators() {
		const { availableIndicators, currentIndicatorsId } = this.state;
		
		availableIndicators.forEach(category => {
			if (currentIndicatorsId.indexOf(category.indicator_id + '') !== -1) { category.selected = true }
			else { category.selected = false }
			category.indicators.forEach(indicator => {
				if (currentIndicatorsId.indexOf(indicator.indicator_id + '') !== -1) { indicator.selected = true }
				else { indicator.selected = false }
			})
		});
		
		this.setState({ availableIndicators: availableIndicators },()=>{
			// console.log('availableIndicators', availableIndicators)
		});
	}
	handleClickBasicSubmit_Close = () => {
		const { currentCounty, countiesData } = this.state;
		countiesData.forEach((item) => {
			if (currentCounty === item.code) {
				this.setState({ currentCountyName: item.county })
			}
		});
		this.setState({ isChartShow: true });
		this.handleGetBasicData();
	}
	handleClickBasicSubmit = () => {
		const { currentCounty, countiesData, selectedCountyTmp } = this.state;
		if(selectedCountyTmp && countiesData.length>0){
			countiesData.forEach((item) => {
				if (currentCounty === item.code) {
					this.setState({ currentCountyName: item.county })
				}
			});
			this.setState({ 
				// isChartShow: true,
				availableIndicatorsValue: [[],[],[],[]],
			},()=>{
				this.handleGetBasicData();
			});
		}
	}
	handleGetAvailableIndicators() {
		return new Promise(resolve => {
			const { selectedCounty, selectedTown } = this.state;
			let countyCode = selectedCounty ? selectedCounty.code : 'all';
			let townCode = selectedTown ? selectedTown.code : 'all';

			Axios.get(`${apiHost}/api/WeakIndex/SValueCompleteWithIndicaotrs?RegionID=${countyCode}&town=${townCode}`)
				.then((res) => {
					if (res.status === 200) {
						const indicatorsData = res.data.Result.indicators;
						const categoriesData = res.data.Result.categories;
						const availableIndicators = [];

						categoriesData.forEach((category) => {
							category.selected = false;
							category.indicators = [];
							indicatorsData.forEach((indicator) => {
								indicator.selected = false;
								if (category.category_id === indicator.category_id) {
									category.indicators.push(indicator);
								}
							})
							availableIndicators.push(category);
						})

						this.setState({ availableIndicators: availableIndicators }, () => resolve())
					}
				})
		})
	}
	handleGetBasicData() {
		const { selectedCountyTmp, selectedTownTmp, isQuery, availableIndicatorsValue, availableIndicatorsValueQuery } = this.state;
		// let county = selectedCountyTmp ? selectedCountyTmp.county : '';
		// let town = selectedTownTmp ? selectedTownTmp.town : '';
		let countyCode = selectedCountyTmp ? selectedCountyTmp.code : 'all';
		let townCode = selectedTownTmp ? selectedTownTmp.code : 'all';

		this.setState({
			isAdvanceLoading: true,
		 });
		Axios.get(`${apiHost}/api/WeakIndex/SValueCompleteWithIndicaotrs?RegionID=${countyCode}&town=${townCode}`)
			.then(res => {
				if (res.status === 200) {
					const indicatorsData = res.data.Result.indicators;
					const categoriesData = res.data.Result.categories;

					
					// 取得全部可用的indicator資料
					const availableIndicators = [];
					categoriesData.forEach((category) => {
						category.selected = false;
						category.indicators = [];
						indicatorsData.forEach((indicator) => {
							indicator.selected = false;
							if (category.category_id === indicator.category_id) {
								category.indicators.push(indicator);
							}
						})
						availableIndicators.push(category);
					})	
					
					let selectedAvailableIndicators = [[], [], [], []];
					let availableIndicatorsValueTmp = [];
					// 指標選單data	
					availableIndicators.map((item) => {
						const category = item.category_id;	
						if(category==1){
							selectedAvailableIndicators[0] = getIndicators(item)
						} else if(category==2){
							selectedAvailableIndicators[1] = getIndicators(item)
						} else if(category==3){
							selectedAvailableIndicators[2] = getIndicators(item)
						} else if(category==4){
							selectedAvailableIndicators[3] = getIndicators(item)
						}
					})	
					if(isQuery){
						availableIndicatorsValueTmp = this.state.availableIndicatorsValueQuery;					

					}else{
						// 全選
						// availableIndicatorsValueTmp = [[], [], [], []];
						// availableIndicators.map((item) => {
						// 	const category = item.category_id;	
						// 	if(category==1){
						// 		availableIndicatorsValueTmp[0] = getIndicatorsValue(item)
						// 	} else if(category==2){
						// 		availableIndicatorsValueTmp[1] = getIndicatorsValue(item)
						// 	} else if(category==3){
						// 		availableIndicatorsValueTmp[2] = getIndicatorsValue(item)
						// 	} else if(category==4){
						// 		availableIndicatorsValueTmp[3] = getIndicatorsValue(item)
						// 	}
						// })	

						
						// 選單與值比對，無在選單的值要移除
						availableIndicatorsValueTmp = availableIndicatorsValue;					
						availableIndicatorsValueTmp = filterValue(indicatorsData, availableIndicatorsValue);
					}
					//選單與值比對，無在選單的值要移除
					function filterValue(indicatorsData, indicatorValue) {
						return indicatorValue.map(subArray => subArray.filter(value => indicatorsData.some(indicator => indicator.indicator_id === value)).map(value => value));
					}

					// 設定選單屬性
					function getIndicators (item) {
						return item.indicators.map((indicator) => ({
							label: indicator.name,
							value: indicator.indicator_id,
							role: indicator.subcategory_name,
							category: indicator.category_id,
						}));
					}
					function getIndicatorsValue(item){
						return item.indicators.map(indicator=>indicator.indicator_id)
					}

					// 檢查是否有待恢復的狀態
					const shouldRestore = this.state.isRestoringFromSession && this.pendingRestoreState;

					// 判斷是否應該保留現有的用戶選擇
					// 如果用戶已經選了任何指標，或已經查詢過結果，就保留相關狀態
					const hasUserSelection = this.state.availableIndicatorsValue &&
						this.state.availableIndicatorsValue.some(arr => arr && arr.length > 0);
					const shouldKeepUserSelection = !shouldRestore && (this.state.isDataLoaded || hasUserSelection);

					this.setState({
						isAdvanceLoading: false,
						currentIndicators: shouldRestore ? this.pendingRestoreState.currentIndicators : (shouldKeepUserSelection ? this.state.currentIndicators : []),
            			currentIndicatorsId: shouldRestore ? this.pendingRestoreState.currentIndicatorsId : (shouldKeepUserSelection ? this.state.currentIndicatorsId : []),
						currentIndicatorsName: [],
						availableIndicators: availableIndicators,
						//測試
						selectedAvailableIndicators,
						availableIndicatorsValue: shouldRestore ? this.pendingRestoreState.availableIndicatorsValue : availableIndicatorsValueTmp,
						isQuery: false,
						pickIndicatorsId: shouldRestore ? this.pendingRestoreState.pickIndicatorsId : (shouldKeepUserSelection ? this.state.pickIndicatorsId : [[],[],[],[],[]]),
						// 恢復查詢結果
						csvData: shouldRestore ? this.pendingRestoreState.csvData : this.state.csvData,
						originCsvData: shouldRestore ? this.pendingRestoreState.originCsvData : this.state.originCsvData,
						sviData: shouldRestore ? this.pendingRestoreState.sviData : this.state.sviData,
						currentTitle: shouldRestore ? this.pendingRestoreState.currentTitle : this.state.currentTitle,
						availableIndicatorsValuePlus: shouldRestore ? this.pendingRestoreState.availableIndicatorsValuePlus : this.state.availableIndicatorsValuePlus,
						availableIndicatorsValueItemsPlus: shouldRestore ? this.pendingRestoreState.availableIndicatorsValueItemsPlus : this.state.availableIndicatorsValueItemsPlus,
						availableIndicatorsData: shouldRestore ? this.pendingRestoreState.availableIndicatorsData : this.state.availableIndicatorsData,
						isDataLoaded: shouldRestore ? this.pendingRestoreState.isDataLoaded : this.state.isDataLoaded,
						categoryChecked: shouldRestore ? this.pendingRestoreState.categoryChecked : (shouldKeepUserSelection ? this.state.categoryChecked : [false, false, false, false]),
						isRestoringFromSession: false,
					}, () => {
						// 清除待恢復狀態
						if (shouldRestore) {
							this.pendingRestoreState = null;
						}
						this.handleValid();
					})
				}
			})
	}
	handleClickAdvanceSubmit = () => {
		this.handleGetAdvanceData();
	}
	handleGetAdvanceData() {
		const { selectedCountyTmp, selectedTownTmp } = this.state;
		const { selectedAvailableIndicators, availableIndicatorsValue, availableIndicatorsValueItems } = this.state;
		let countyCode = selectedCountyTmp ? selectedCountyTmp.code : 'all';
		let county = selectedCountyTmp ? selectedCountyTmp.county : '';
		let townCode = selectedTownTmp ? selectedTownTmp.code : 'all';
		let town = selectedTownTmp ? selectedTownTmp.town : '';
		
		this.setState({	
			// isAdvanceLoading: true,
			isING: true,
		 });
		
		// 測試：Value N+4	(深拷貝)
		let availableIndicatorsValuePlus = JSON.parse(JSON.stringify(availableIndicatorsValue))
		availableIndicatorsValuePlus[0].unshift(1);
		availableIndicatorsValuePlus[1].unshift(2);
		availableIndicatorsValuePlus[2].unshift(3);
		availableIndicatorsValuePlus[3].unshift(4);

		let currentIndicatorsId = [0, ...availableIndicatorsValuePlus.flat()];
		
		Axios.get(`${apiHost}/api/WeakIndex/SValueMultiple?region_id=${countyCode}&indicators=${currentIndicatorsId.join('%2B')}&town=${townCode}`)
		.then((res) => {
			if (res.status === 200) {
						
				// 設定綜合指標為預設資料
				const availableIndicatorsData = res.data.Result;
				let csvData = []
				let originCsvData = []
				let sviData = []
				csvData = csvData.concat(availableIndicatorsData[0].csv);
				if (availableIndicatorsData[0].csvOrigin) {
					originCsvData = originCsvData.concat(availableIndicatorsData[0].csvOrigin);
				}
				sviData = sviData.concat(availableIndicatorsData[0].data);
				// console.log('sviData', sviData);
				
				// 設定availableIndicatorsValueItems的值
				availableIndicatorsValue.map((value, index)=>{
					availableIndicatorsValueItems[index]=availableIndicatorsValue[index].map(id=>{						 
						return selectedAvailableIndicators[index].find(item=>id==item.value)
					});
				})

				// 設定availableIndicatorsValueItemsPlus的值
				let availableIndicatorsValueItemsPlus = JSON.parse(JSON.stringify(availableIndicatorsValueItems))
				availableIndicatorsValueItemsPlus[0].unshift({
					label: "暴露量",
					value: 1
				})
				availableIndicatorsValueItemsPlus[1].unshift({
					label: "減災整備",
					value: 2
				})
				availableIndicatorsValueItemsPlus[2].unshift({
					label: "應變能力",
					value: 3
				})
				availableIndicatorsValueItemsPlus[3].unshift({
					label: "復原能力",
					value: 4
				})

				this.setState({
					currentTitle: `${county+town} 歷年社會脆弱度指標`,
					isDataLoaded: true,
					isAdvanceLoading: false,
					sviData: sviData,
					csvData: csvData,
					originCsvData: originCsvData,
					// 測試
					availableIndicatorsValuePlus,
					availableIndicatorsValueItemsPlus,
					currentIndicatorsId,
					availableIndicatorsData,
					pickIndicatorsId: [[0],[],[],[],[]],
					currentIndicators: [],
					isING: false,
					categoryChecked: [false, false, false, false]
				}, () => {
					// 儲存查詢結果到 sessionStorage
					this.updateSessionStorage();

					const indicatorsQuery = currentIndicatorsId.map(indicator => {
						return `&indicator=${indicator}`
					})
					// urlPushState(`?county=${countyCode}&town=${townCode}${indicatorsQuery.join('')}`);
				})
			}
		})
	}
	handleClickRemoveIndicators = () => {
		this.setState({
			currentIndicatorsId: [],
		}, () => this.handleUpdateIndicators())
	}
	handleChangeCounty = (value) => {
		return new Promise(resolve => {
			this.setState({
				currentCounty: value,
				currentIndicatorsId: [],
				isBasicLoaded: false
			}, () => resolve());
		})
	}
	handleClickDownloadPNG = (e) => {
		e.preventDefault();
		const { selectedCountyTmp, selectedTownTmp } = this.state;
		const countyName = selectedCountyTmp ? selectedCountyTmp.county : '';
		const townName = selectedTownTmp ? selectedTownTmp.town : '';
		const fileName = `${countyName}${townName} 歷年社會脆弱度趨勢`;
		const captureArea = document.querySelectorAll('.capture');
		chartCapture(captureArea, fileName, null, null, true);
		gaTracking('社會脆弱度', '社會脆弱度指標查詢與展示', '圖表下載');
	}
	handleClickDownloadCSV = (e) => {
		const { csvData, originCsvData, currentCountyName, currentIndicatorsId, allIndicators, indicatorsDetails } = this.state;
		let csv = '';
		// 優先用 originCsvData (未四捨五入的原始值)，沒有才 fallback 到 csvData
		const downloadSource = (originCsvData && originCsvData.length > 0) ? originCsvData : csvData;
		downloadSource.forEach((item) => {
			csv = csv + '\n' + item.title + '\n' + item.csv;
		});
		let allSource = []
		indicatorsDetails.forEach(indicator =>{
			let description = indicator.description.replace(/<[^>]+>|[a-z]|[\*]/g,'')
			if(indicator.source){
				allSource.push({
					indicator_id: indicator.indicator_id.toString(),
					name: indicator.name,
					description: description,
					source: indicator.source[0]
				})
			}
		})
		let sources = allSource.filter(src =>{
			return currentIndicatorsId.includes(src.indicator_id)
		});

		const fileName = `${currentCountyName}原始資料`;

		let copyright = '\n資料來源：減災動資料'
		if (sources.length !== 0){
			copyright += "\n\n註解:"
			for(let source of sources){
				if(source.name && source.description && source.source){
					copyright += `\n---------------------------------------------------\n指標項:${source.name}\n${source.description}\n原始數據來源:${source.source}\n`
				}
			}
		}
		const csvContent = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csv) + copyright;

		downloadTrigger(fileName + '.csv', csvContent);
		gaTracking('社會脆弱度', '社會脆弱度指標查詢與展示', '原始數據下載');

	}
	handleCountyDistrictPickSelected = selectedCode => {
		return new Promise(resolve => {
			const { countiesData, isQuery } = this.state;
			const selectedDistrict = countiesData.find( ({ code }) => code === selectedCode );
			if(selectedDistrict){
				this.setState({ 
					availableIndicators: null,
					selectedCountyTmp: selectedDistrict,
					selectedTownTmp: null,
					selectedTownCode: '', // 重置鄉鎮選擇
					townsData: selectedDistrict.towns,
					isValid: false // 重置驗證狀態
				}, () => {
					// 移除自動調用 handleGetBasicData
					// isQuery || this.handleGetBasicData();
					resolve();
				});
			}
		})
	}
	handleTownDistrictPickSelected = selectedCode => {
		return new Promise(resolve => {
			const { townsData, isQuery } = this.state;
			if (!selectedCode || selectedCode === '') {
				// 如果沒有選擇鄉鎮，清空相關狀態
				this.setState({
					selectedTownTmp: null,
					selectedTownCode: '',
					availableIndicators: null,
					isValid: false
				}, () => {
					resolve();
				});
				return;
			}
			
			let selectedTown = null;
			if (selectedCode === '0') {
				// 全選的情況，設定為null（代表全選）
				selectedTown = null;
			} else {
				// 選擇特定鄉鎮
				selectedTown = townsData.find( ({ code }) => code === selectedCode );
			}
			
			this.setState({
				availableIndicators: null,
				selectedTownTmp: selectedTown,
				selectedTownCode: selectedCode,
			}, () => {
				// 只有在選擇了鄉鎮後才調用 handleGetBasicData
				this.handleGetBasicData();
				resolve();
			});
		})
	}

	//測試
	handleTableCollapseToggle = () => {
		this.setState({
			tableCollapseToggle: !this.state.tableCollapseToggle
		},()=>{

		}) 
	}
	//all  Collapse toggle
	handleCollapseToggle = (pos) => {
		
		let state = {...this.state.isShowCollapse};
		state[pos]=!this.state.isShowCollapse[pos];
		if(pos==0){
			if(this.state.isShowCollapse[0]){
				state = [false, false, false, false, false];
			}else{
				state = [true, true, true, true, true];
			}
		}
		
		this.setState({
			isShowCollapse: state
		})
	}
	// 指標清除
	handleDeleteAll = () => {
		this.setState({
			pickIndicatorsId: [[],[],[],[],[]],
			currentIndicators: [],
			sviData: [],
			csvData: [],
			originCsvData: [],
			categoryChecked: [false, false, false, false]
		},()=>{
			
		})
	}
	// 單一指標Clcik
	handleClickAdvanceLink = (category, value, e) => {
		const {selectedTownTmp} = this.state;
		const {availableIndicatorsData, allIndicators, pickIndicatorsId} = this.state;
		let town = selectedTownTmp ? selectedTownTmp.town : '';
		// let csvData = [availableIndicatorsData[0].csv];
		// let sviData = [...availableIndicatorsData[0].data];
		let csvData = [];
		let originCsvData = [];
		let sviData = [];
		const currentIndicators = [];
		// console.log('selectedTownTmp', selectedTownTmp);
		// console.log('category, value', category, value);
		// console.log('e', e);
		// console.log('availableIndicatorsData', availableIndicatorsData);
			// 判斷陣列中是否有值
			const index = pickIndicatorsId[category].indexOf(value);
			if (index === -1 ) {
				if(pickIndicatorsId.flat().length<10) {
					pickIndicatorsId[category].push(value)
				}else{
					alert('指標趨勢線(含綜合指標)不得超過10個')
				};
			} else {
				pickIndicatorsId[category].splice(index, 1);
			}
			
			// 賦於資料
			pickIndicatorsId.flat().forEach(id => {
				// csv & svi
				availableIndicatorsData.forEach(item=>{
					if (item.data.length>0 && Number(item.data[0].indicator_id) == id){
						csvData=csvData.concat(item.csv);
						if (item.csvOrigin) {
							originCsvData = originCsvData.concat(item.csvOrigin);
						}
						sviData=sviData.concat(item.data);
					}
				})
				// 描述
				allIndicators.forEach((item) => {
					// console.table([['town',town],['county',item.county],['indicator_id',item.indicator_id],['id', id]]);
					if(item.indicator_id === Number(id)){
						if(Number(id)===1 || Number(id)===2 || Number(id)===3 || Number(id)===4){
							currentIndicators.push(item)
						}else{

							if(town === '') {
								if (item.county) {
									currentIndicators.push(item)
								}
								return
							}
							if (!item.county) {
								currentIndicators.push(item)
							}	
						}
					}				
				})
			})
			if(e !== undefined){
				const categoryChecked = {...this.state.categoryChecked}
				categoryChecked[category-1]=e
				this.setState({categoryChecked})
			}
			
			this.setState({
				pickIndicatorsId,
				currentIndicators,
				sviData,
				csvData,
				originCsvData
			},()=>{
				// 更新 sessionStorage 中的查詢結果
				this.updateSessionStorage();

				// console.log('allIndicators',this.state.allIndicators)
				// console.log('pickIndicatorsId',this.state.pickIndicatorsId)
				// console.log('currentIndicators',this.state.currentIndicators)
				// console.log('sviData',this.state.sviData)
				// console.log('csvData',this.state.csvData)
			})
		
	}
	// 指標選單Change
	handleSelectedAvailableIndicatorsChange = (value, position) => {
		const {selectedAvailableIndicators, availableIndicatorsValue, availableIndicatorsValueItems} = this.state;		
		// 被選的值
		availableIndicatorsValue[position]=value;
		// 值的item內容
		// availableIndicatorsValueItems[position]=availableIndicatorsValue[position].map(id=>{
		// 	return selectedAvailableIndicators[position].find(item=>id==item.value)
		// });
		this.setState({ 
			availableIndicatorsValue,
			// availableIndicatorsValueItems
		 }, ()=>{
			this.handleValid(); 
			// console.log('availableIndicatorsValue', this.state.availableIndicatorsValue)
			
		 })		
	}
	// 驗證
	handleValid = () => {
		const {isAdvanceLoading, availableIndicatorsValue, selectedTownCode, selectedCountyTmp} = this.state;
		const hasData = availableIndicatorsValue.every(item=>item.length>0);
		const hasSelectedCounty = selectedCountyTmp !== null;
		const hasSelectedTown = selectedTownCode !== '';
		let isValid = false;
		
		if(isAdvanceLoading == false && hasData && hasSelectedCounty && hasSelectedTown){
			isValid= true;
		}else{
			isValid= false;
		}
		this.setState({isValid},()=>{
			// console.log('isValid', this.state.isValid)
		})
	}
	// 指標選項全選
	handleSelectedAvailableIndicatorsAll = (position) => {
		const {selectedAvailableIndicators, availableIndicatorsValue, availableIndicatorsValueItems} = this.state;
		availableIndicatorsValue[position]=selectedAvailableIndicators[position].map(item=>item.value);
		// availableIndicatorsValueItems[position]=selectedAvailableIndicators[position];
		this.setState({ 
			availableIndicatorsValue,  
			// availableIndicatorsValueItems
		}, ()=>{
			this.handleValid();
			// console.log('availableIndicatorsValue', availableIndicatorsValue)
			// console.log('availableIndicatorsValueItems', availableIndicatorsValueItems)
		});
	}
	
	
	
	render() {
    	const { isMemberLogin } = this.state;
		const { availableIndicators, categoryDescription } = this.state;
    	const { countiesData, townsData } = this.state;
		const { currentIndicators, currentIndicatorsId, currentTitle } = this.state;
    	const { selectedCounty, selectedTown } = this.state;
		const { type, sviData, csvData } = this.state;
		const { isChartShow, isBasicLoading, isBasicLoaded, isAdvanceLoading } = this.state;
		//測試
		const { legendSelected } = this.state;
		const { selectedAvailableIndicators, 
				availableIndicatorsValue ,
				availableIndicatorsValueItems,
				isValid } = this.state;
		return (
			<React.Fragment>
				<Helmet>
					<title>減災動資料 - 社會脆弱度評估</title>
				</Helmet>
				<LimitMask prevPage="/evaluation/svi" />
	{/*			{
					test_data &&
					<div className="" style={{background: '#FFF', position: 'fixed', zIndex: 999, left: '10%', top: '10%', padding: '24px', boxShadow: '2px 4px 12px #000'}}>
						<p>計算數據</p>
						{
							test_data['Result'].map((item, i) => 
							<div key={i} style={{ maxHeight: '200px', overflow: 'auto'}}>
								<p>NAME { item['name'] }</p>
								<div style={{ color: 'hsla(0, 80%, 40%)' }}>C_Value <br/>{ item['C_Value'].map(c => 
									<p key={c.year+c.value}> {c.year}: {c.value} </p>
								) }</div>
								<p style={{ color: 'hsla(100, 80%, 40%)' }}>A_Value { item['A_Value'] }</p>
								<div style={{ color: 'hsla(200, 80%, 40%)' }}>B_Value { item['B_Value'].map(b => 
									<p key={b.year+b.value}> {b.year}: {b.value}</p>
								) }</div>
								<hr/>
							</div>)
						}
					</div>
				}*/}
				<div className="svi-page">
					<div className="container">
						<div className="page-link">
							<Link  className="item" to="/evaluation/svi/advance">
								<span>客製化社會脆弱度評估</span>
							</Link>
						</div>
						<div className="svi-charttitle">
							<div className="title">社會脆弱度指標查詢與展示</div>
							<div className="subtitle">Social Vulnerability Index for Disasters</div>
						</div>
						<div className="svi-chart row">
							<div className="col-md-3 chart-controller">
								<div className="type">
									<div className="step">
										<div className="title">
											<span className="en">Step 1 </span>
											<span>選擇想查看的資料主題</span>
										</div>
										<div className="buttonbar">
											<Link to="/evaluation/svi/z"
											onMouseEnter={() => this.setState({ type: 'z' })}
											onMouseOut={() => this.setState({ type: 's' })}>單一年度行政區比較</Link>
											<Link to="/evaluation/svi/s" className="-active"
											onMouseEnter={() => this.setState({ type: 's' })}
											onMouseOut={() => this.setState({ type: 's' })}>單一行政區歷史趨勢</Link>
										</div>
										<div className="info">
											{ type === 'z' &&	<p>單一年度行政區比較：可了解不同縣市之間社會脆弱度的程度。</p> }
											{ type === 's' && <p>單一行政區趨勢：可了解如臺北市 1998 到 2016 年間的社會脆弱度趨勢。</p> }
										</div>
									</div>
								</div>
								<div className="basic">
									<div className="step">
										<div className="title">
											<span className="en">Step 2 </span>
											<span>選擇縣市</span>
										</div>
										<div className="select">
										<CustomSelect status="normal" name="year"
											value={this.state.selectedCountyTmp ? this.state.selectedCountyTmp.code : ''}
											onChange={value => this.handleCountyDistrictPickSelected(value)}>
											<option value="0">縣市</option>
											{
											countiesData &&
											countiesData.map((item, index) =>
												<option key={index} value={item.code}>{item.county}</option>
											)
											}
										</CustomSelect>
										</div>
									</div>
									{
										<div className="step">
											<div className="title">
												<span className="en">Step 3 </span>
												<span>選擇鄉鎮</span>
											</div>
											<div className="select">
												<CustomSelect status="normal" name="county"
												value={this.state.selectedTownCode}
												onChange={(value) => { this.handleTownDistrictPickSelected(value) }}>
												<option value="">請選擇</option>
												<option value="0">全選</option>
												{
													townsData &&
													townsData.map((item, index) => 
													<option key={index} value={item.code}>{item.town}</option>
													)
												}
												</CustomSelect>
											</div>
										</div>
									}
									{
										availableIndicators &&
										<div className="step">
											<div className="title">Step 4 選擇想要評估的指標</div>
											{/* 暴露量 */}
											<div className="info mb-1">
												<div className='category-title'><span className='text-danger'>*</span>
													暴露量 
													({ `${this.state.availableIndicatorsValue[0].length} / 
														${this.state.selectedAvailableIndicators[0].length}` })
													{/* ({ `${this.state.availableIndicatorsValue[0].length}` }) */}
												</div>
												{ this.state.selectedAvailableIndicators[0].length>0 &&
													<button className='link' onClick={()=>this.handleSelectedAvailableIndicatorsAll(0)}>全選</button>}
											</div>
											<div className="select">
												{ (!this.state.selectedAvailableIndicators[0].length>0 
														&& <div className='noData'>無資料</div>) || 
													this.state.selectedAvailableIndicators[0] &&
													<TagPicker 
														data={selectedAvailableIndicators[0]} 
														value={availableIndicatorsValue[0]} 
														onChange={(value)=>this.handleSelectedAvailableIndicatorsChange(value, 0)}
														placeholder='請選擇'
														groupBy="role" 
														block
														renderMenuGroup={(label, item) => {
															return (
																<>{label} </> 
															);
														}}
														searchable={false}
														
													/> }		
											</div>
											{ (this.state.selectedAvailableIndicators[0].length>0 && 
													!this.state.availableIndicatorsValue[0].length>0)  &&
												<div className='text-danger mb-10 mt-n2'>至少勾選一項</div> }	
											{/* 減災整備 */}
											<div className="info mb-1">
												<div className='category-title'><span className='text-danger'>*</span>
													減災整備 
													({ `${this.state.availableIndicatorsValue[1].length} / 
														${this.state.selectedAvailableIndicators[1].length}` })
													{/* ({ `${this.state.availableIndicatorsValue[1].length}` }) */}
												</div>
												{ this.state.selectedAvailableIndicators[1].length>0 &&
													<button className='link' onClick={()=>this.handleSelectedAvailableIndicatorsAll(1)}>全選</button>}
											</div>
											<div className="select">
												{ (!this.state.selectedAvailableIndicators[1].length>0 
														&& <div className='noData'>無資料</div>) || 
													this.state.selectedAvailableIndicators[1] &&
													<TagPicker 
														data={selectedAvailableIndicators[1]} 
														value={availableIndicatorsValue[1]} 
														onChange={(value)=>this.handleSelectedAvailableIndicatorsChange(value, 1)}
														placeholder='請選擇'
														groupBy="role" 
														block
														renderMenuGroup={(label, item) => {
															return (
																<>{label} </>
															);
														}}
														searchable={false}
													/> }		
											</div>
											{ (this.state.selectedAvailableIndicators[1].length>0 && 
													!this.state.availableIndicatorsValue[1].length>0)  &&
												<div className='text-danger mb-10 mt-n2'>至少勾選一項</div> }	
											{/* 應變能力 */}
											<div className="info mb-1">
												<div className='category-title'><span className='text-danger'>*</span>
													應變能力 
													({ `${this.state.availableIndicatorsValue[2].length} / 
														${this.state.selectedAvailableIndicators[2].length}` })
													{/* ({ `${this.state.availableIndicatorsValue[2].length}` }) */}
												</div>
												{ this.state.selectedAvailableIndicators[2].length>0 &&
													<button className='link' onClick={()=>this.handleSelectedAvailableIndicatorsAll(2)}>全選</button>}
											</div>
											<div className="select">
												{ (!this.state.selectedAvailableIndicators[2].length>0 
														&& <div className='noData'>無資料</div>) || 
													this.state.selectedAvailableIndicators[2] &&
													<TagPicker 
														data={selectedAvailableIndicators[2]} 
														value={availableIndicatorsValue[2]} 
														onChange={(value)=>this.handleSelectedAvailableIndicatorsChange(value, 2)}
														placeholder='請選擇'
														groupBy="role" 
														block
														renderMenuGroup={(label, item) => {
															return (
																<>{label} </>
															);
														}}
														searchable={false}
													/> }		
											</div>
											{ (this.state.selectedAvailableIndicators[2].length>0 && 
													!this.state.availableIndicatorsValue[2].length>0)  &&
												<div className='text-danger mb-10 mt-n2'>至少勾選一項</div> }	
											
											{/* 復原能力 */}
											<div className="info mb-1">
												<div className='category-title'><span className='text-danger'>*</span>
													復原能力 
													({ `${this.state.availableIndicatorsValue[3].length} / 
														${this.state.selectedAvailableIndicators[3].length}` })
													{/* ({ `${this.state.availableIndicatorsValue[3].length}` }) */}
												</div>
												{ this.state.selectedAvailableIndicators[3].length>0 &&
													<button className='link' onClick={()=>this.handleSelectedAvailableIndicatorsAll(3)}>全選</button>}
											</div>
											<div className="select">
												{ (!this.state.selectedAvailableIndicators[3].length>0 
														&& <div className='noData'>無資料</div>) || 
													this.state.selectedAvailableIndicators[3] &&
													<TagPicker 
														data={selectedAvailableIndicators[3]} 
														value={availableIndicatorsValue[3]} 
														onChange={(value)=>this.handleSelectedAvailableIndicatorsChange(value, 3)}
														placeholder='請選擇'
														groupBy="role" 
														block
														renderMenuGroup={(label, item) => {
															return (
																<>{label} </>
															);
														}}
														searchable={false}
													/> }		
											</div>
											{ (this.state.selectedAvailableIndicators[3].length>0 && 
													!this.state.availableIndicatorsValue[3].length>0)  &&
												<div className='text-danger mb-10 mt-n2'>至少勾選一項</div> }	
										</div>
									}
									{/* 看評估結果 */}
									<div className="submit">
										<button className={"button" + (isAdvanceLoading || this.state.isING ? ' -loading' : '')}
										disabled = { isAdvanceLoading || isValid == false || this.state.isING }
										onClick={this.handleClickAdvanceSubmit}>看評估結果</button>
									</div>
								</div>
							</div>
							{
								// isChartShow &&
								
								<div className="col-md-9 chart-result">
									{
										this.state.isING &&
										<div className="chart">
											<LoadingDots theme="blue" >
												<p>系統處理中....請稍待</p>
											</LoadingDots>
										</div>
									}
									{
										!this.state.isING && this.state.isDataLoaded &&
										<>
										<div className="heading capture">
											<div className="title">{ currentTitle }</div>
											<div className="dropdown" data-html2canvas-ignore>
												<CustomDropdown title="下載">
													<li><button onClick={this.handleClickDownloadPNG}>下載PNG</button></li>
												</CustomDropdown>
											</div>
										</div>
										<div className={"chart capture"}>
											{/* { isAdvanceLoading && <LoadingDots theme="blue" />} */}
											<SviChartLine sviData={sviData} legendSelected={legendSelected}></SviChartLine>
										</div>
										
										{
											<div className="info capture scroll mb-5" style={{marginTop: -40+'px'}} id='info'>
												{
													(this.state.pickIndicatorsId.flat().includes(0) || currentIndicators.length !== 0) &&
													<div className="title">指標定義說明</div>
												}
												{
													this.state.pickIndicatorsId.flat().includes(0) &&
													<>
													<div className="content"><strong>• 歷年社會脆弱度趨勢值</strong></div>
													<div className="content mb-2">上圖展示各縣市社會脆弱度綜合指數（S），依據本站所列之指標項目進行綜合計算而得（詳首頁說明），以第一年為基準值 100，比較每一年的情況，指數大於第一年表示脆弱度升高，反之則降低。部分年度／縣市因缺乏資料，無法計算。</div>
													
													</>
												}
												{
													currentIndicators.length !== 0 &&
													currentIndicators.map((indicator, i) =>													
														<React.Fragment key={i}>
															<div className="content"><strong>• {indicator.name}</strong></div>
															<div className="content mb-2" dangerouslySetInnerHTML={{ __html: indicator.descriptionhistory }}/>
															{
																categoryDescription && categoryDescription.map((category, j) =>
																<React.Fragment key={j}>
																	{ 
																		category.name ===	indicator.name && 
																		<div className="content" dangerouslySetInnerHTML={{ __html: category.description }}/>
																	}
																</React.Fragment>)
															}															
														</React.Fragment>
													)
												}
											</div>
										}
										{
											
											<div className='categoriesContainer mb-3'>
												<div className='hstack-between mb-3'>
													<div className='hstack gap-16'>
														<h3 className='Indicators-title'>細部查看各分類或各指標</h3>
														複選，10個以內
													</div>
													<div className='hstack gap-16'>
														<div>{this.state.pickIndicatorsId.flat().length}  / 10</div>
														<button className='link' onClick={()=>this.handleDeleteAll()}>清除選取</button>
													</div>
												</div>
												<div className='hstack-between mb-3'>
													<div className='indicatordeSlinks'>
														<button 
															onClick={()=>this.handleClickAdvanceLink(0,0)}
															className={ (this.state.pickIndicatorsId[0].includes(0) ? 'active' : '')}
														>綜合結果</button> 	
													</div>
													<div>
														<button className='link' aria-expanded={this.state.isShowCollapse[0]?'true':'false'} onClick={()=>this.handleCollapseToggle(0)}>全部</button>
													</div>
												</div>
												{
													this.state.availableIndicatorsValueItemsPlus[0].length>0 &&
													<>
													<div className='item'>
														<div className='hstack gap-4'>
															<CustomCheckbox
																// id="allowlogin"
																className="checkbox"
																checked={this.state.categoryChecked[0]}
																onChange={(e) => this.handleClickAdvanceLink(1,1,e)}
																>
																<span className='toggleContainer'>
																	<span className='text'>暴露量</span>												
																</span>
															</CustomCheckbox>
															<span className='fs-14'>({this.state.pickIndicatorsId[1].length})</span>
															<button className='link ms-auto' aria-expanded={this.state.isShowCollapse[1]?'true':'false'} onClick={()=>this.handleCollapseToggle(1)}></button>
														</div>
														<div className={this.state.isShowCollapse[1]?'collapse show':'collapse'}>
															<div className='indicatordeSlinks checked noneFirstItem'>
																{
																	this.state.availableIndicatorsValueItemsPlus[0].map((item,index) => {
																		const { label, value, role } = item;
																		return (
																			<>
																			<button 
																				onClick={()=>this.handleClickAdvanceLink(1,value)} 
																				className={(this.state.pickIndicatorsId[1].includes(value) ? 'active' : '')}
																				key={item.label}>{ index==0 ? label : `${label}`}</button> 
																			</>		
																		)
				
																	})
																}
															</div>
														</div>
													</div>
													</>
												}
												{
													this.state.availableIndicatorsValueItemsPlus[1].length>0 &&
													<div className='item'>
														<div className='hstack gap-4'>
															<CustomCheckbox
																// id="allowlogin"
																className="checkbox"
																checked={this.state.categoryChecked[1]}
																onChange={(e) => this.handleClickAdvanceLink(2,2,e)}
																>
																<span className='toggleContainer'>
																	<span className='text'>減災整備</span>												
																</span>
															</CustomCheckbox>
															<span className='fs-14'>({this.state.pickIndicatorsId[2].length})</span>
															<button className='link ms-auto' aria-expanded={this.state.isShowCollapse[2]?'true':'false'} onClick={()=>this.handleCollapseToggle(2)}></button>
														</div>
														<div className={this.state.isShowCollapse[2]?'collapse show':'collapse'}>
															<div className='indicatordeSlinks checked noneFirstItem'>
															{
																this.state.availableIndicatorsValueItemsPlus[1].map((item,index) => {
																	const { label, value, role } = item;
																	return (
																		<>
																		<button 
																			onClick={()=>this.handleClickAdvanceLink(2,value)} 
																			className={(this.state.pickIndicatorsId[2].includes(value) ? 'active' : '')}
																			key={item.label}>{ index==0 ? label : `${label}`}</button> 
																		</>		
																	)
			
																})
															}
															</div>
														</div>
													</div>
												}
												{
													this.state.availableIndicatorsValueItemsPlus[2].length>0 &&
													<div className='item'>
														<div className='hstack gap-4'>
															<CustomCheckbox
																// id="allowlogin"
																className="checkbox"
																checked={this.state.categoryChecked[2]}
																onChange={(e) => this.handleClickAdvanceLink(3,3,e)}
																>
																<span className='toggleContainer'>
																	<span className='text'>應變能力</span>												
																</span>
															</CustomCheckbox>
															<span className='fs-14'>({this.state.pickIndicatorsId[3].length})</span>
															<button className='link ms-auto' aria-expanded={this.state.isShowCollapse[3]?'true':'false'} onClick={()=>this.handleCollapseToggle(3)}></button>
														</div>
														<div className={this.state.isShowCollapse[3]?'collapse show':'collapse'}>
															<div className='indicatordeSlinks checked noneFirstItem'>
																{
																	this.state.availableIndicatorsValueItemsPlus[2].map((item,index) => {
																		const { label, value, role } = item;
																		return (
																			<>
																			<button 
																				onClick={()=>this.handleClickAdvanceLink(3, value)} 
																				className={(this.state.pickIndicatorsId[3].includes(value) ? 'active' : '')}
																				key={item.label}>{ index==0 ? label : `${label}`}</button> 
																			</>		
																		)
				
																	})
																}
															</div>
														</div>
													</div>
												}
												{
													this.state.availableIndicatorsValueItemsPlus[3].length>0 &&
													<div className='item'>
														<div className='hstack gap-4'>
															<CustomCheckbox
																// id="allowlogin"
																className="checkbox"
																checked={this.state.categoryChecked[3]}
																onChange={(e) => this.handleClickAdvanceLink(4,4,e)}
																>
																<span className='toggleContainer'>
																	<span className='text'>復原能力</span>												
																</span>
															</CustomCheckbox>
															<span className='fs-14'>({this.state.pickIndicatorsId[4].length})</span>
															<button className='link ms-auto' aria-expanded={this.state.isShowCollapse[4]?'true':'false'} onClick={()=>this.handleCollapseToggle(4)}></button>
														</div>
														<div className={this.state.isShowCollapse[4]?'collapse show':'collapse'}>
															<div className='indicatordeSlinks checked noneFirstItem'>
																{
																	this.state.availableIndicatorsValueItemsPlus[3].map((item,index) => {
																		const { label, value, role } = item;
																		return (
																			<>
																			<button 
																				onClick={()=>this.handleClickAdvanceLink(4, value)} 
																				className={(this.state.pickIndicatorsId[4].includes(value) ? 'active' : '')}
																				key={item.label}>{ index==0 ? label : `${label}`}</button> 
																			</>		
																		)
				
																	})
																}
															</div>
														</div>
													</div>
												}
											</div>
										}
										<React.Fragment>
											{
												// currentIndicators.length === 0 &&
												// <div className="info capture">
												// 	<div className="title">說明</div>
												// 	<div className="content">上圖展示各縣市社會脆弱度綜合指數（S），依據本站所列之指標項目進行綜合計算而得（詳首頁說明），以第一年為基準值 100，比較每一年的情況，指數大於第一年表示脆弱度升高，反之則降低。部分年度／縣市因缺乏資料，無法計算。</div>
												// </div>
											}
											<div className="origin">
												<div className="title">
													<div className="text">原始數據</div>
													<div className='hstack gap-16'>
														<CustomDropdown title="下載">
															{ isMemberLogin && <li><button onClick={this.handleClickDownloadCSV}>下載CSV</button></li> }
															{ !isMemberLogin && <li><button onClick={loginRedirect}>登入會員下載CSV</button></li> }
														</CustomDropdown>
														<button className='link' aria-expanded={this.state.tableCollapseToggle?'true':'false'} onClick={()=>this.handleTableCollapseToggle()}></button>
													</div>
												</div>
												<div className="table" style={this.state.tableCollapseToggle?{maxHeight:'unset'}:{}}>
													<SviChartTable csvData={csvData} />
												</div>
												<p className="remark">*標記*為非公開資料，如有任何問題請 <a href="/#contact" target="_blank" rel="noopener noreferrer">聯絡我們</a></p>
											</div>
										</React.Fragment>
										</>
									}
								</div>
							}
						</div>
					</div>
				</div>
				<SocialBlock category="社會脆弱度" action="社會脆弱度指標查詢與展示" theme="blue" />
			</React.Fragment>
		);
	}
}

export default SviChart;
